import {
  LayoutDashboard,
  Send,
  Users,
  BarChart3,
  Settings,
  FileText,
  CreditCard,
  MessageSquare,
} from 'lucide-react';
import { AppShell, type NavGroup } from '@/shell/AppShell';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const navGroups: NavGroup[] = [
  {
    label: 'Overview',
    items: [
      { to: '/preview-shell', label: 'Dashboard', icon: LayoutDashboard },
      { to: '/preview-shell/reports', label: 'Reports', icon: BarChart3 },
    ],
  },
  {
    label: 'Messaging',
    items: [
      { to: '/preview-shell/single', label: 'Single message', icon: Send },
      { to: '/preview-shell/templates', label: 'Templates', icon: FileText },
      { to: '/preview-shell/chat', label: 'Chat', icon: MessageSquare },
    ],
  },
  {
    label: 'Account',
    items: [
      { to: '/preview-shell/contacts', label: 'Contacts', icon: Users },
      { to: '/preview-shell/credit', label: 'Credit', icon: CreditCard },
      { to: '/preview-shell/settings', label: 'Settings', icon: Settings },
    ],
  },
];

export default function PreviewShell() {
  return (
    <AppShell
      navGroups={navGroups}
      user={{
        name: 'Benoit Dausse',
        email: 'bdausse@smsreflex.com',
      }}
      onLogout={() => alert('Logout clicked (preview only)')}
    >
      <div className="space-y-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Preview Shell</h1>
          <p className="text-sm text-muted-foreground">
            Démo du shell Tailwind + shadcn (Phase 3). Sera utilisé par les
            pages migrées en Phase 4.
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Sidebar</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Collapsible (clique sur la chevron en haut). Active state
                appliqué via NavLink. Items groupés par section.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Topbar</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Theme toggle (light/dark/system) + user menu avec avatar et
                action logout.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Outlet</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">
                Le contenu principal vient soit du <code>{'<Outlet>'}</code>{' '}
                de react-router (mode production), soit de{' '}
                <code>children</code> (mode démo).
              </p>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Test theme</CardTitle>
          </CardHeader>
          <CardContent className="flex flex-wrap gap-2">
            <Button>Primary</Button>
            <Button variant="secondary">Secondary</Button>
            <Button variant="outline">Outline</Button>
            <Button variant="ghost">Ghost</Button>
            <Button variant="destructive">Destructive</Button>
          </CardContent>
        </Card>
      </div>
    </AppShell>
  );
}
